import { getUser } from "$lib/userstorage/usersotrage"
import { handleAuthenticatedRequest, jsonOrThrow } from "../errores/erroresback"
import { queryClient, cacheRestored } from "$lib/query/queryClient"
import { queryKeys } from "$lib/query/keys"
let ruta_java = import.meta.env.VITE_RUTA_JAVA_SERVER;
let ruta_local_java = import.meta.env.VITE_RUTA_LOCAL_JAVA_SERVER;
let bd_local = import.meta.env.VITE_LOCAL_BD=="si";
let RUTA_JAVA =bd_local? ruta_local_java:ruta_java;
const RUTA_OBSERVACIONES = "comments"
function processComment(comment) {
    let data_comm = {
        id: comment.commentId,
        fecha: comment.observationDate,
        animal: comment.animalId,
        observacion: comment.notes,
        active: comment.isActive,
        cab: comment.establishmentId,
        expand: {
            animal: {
                id: comment.animalId,
                caravana: comment.animalTagNumber
            }
        }
    }
    return data_comm
}
export function processComments(data, cabid = null) {
    let data_comments = []
    for (let i = 0; i < data.length; i++) {
        let fila = data[i]
        if (fila.isActive) {
            if (cabid) {
                if (fila.establishmentId == cabid) {
                    data_comments.push(processComment(fila))
                }
            }
            else {
                data_comments.push(processComment(fila))
            }

        }

    }
    return data_comments
}
function isRealError(err) {
    return !!err && (err.message === "SESIÓN_EXPIRADA" || err.message === "SIN_PERMISO" || typeof err.status === "number")
}
export async function getAll(cabid = null) {
    let user = getUser();
    let token = user.token;

    let ruta = `${RUTA_JAVA}${RUTA_OBSERVACIONES}/all`
    let url = new URL(ruta)
    if (cabid) {
        url.searchParams.append('establishmentId', cabid);
    }
    let options = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        }
    }

    try {
        let res_all = await handleAuthenticatedRequest(url.toString(), options)

        let data_all = await jsonOrThrow(res_all, "observaciones.getAll")

        return processComments(data_all,cabid)
    } catch (err) {
        if (isRealError(err)) throw err
        await cacheRestored
        const cached = cabid ? queryClient.getQueryData(queryKeys.observations(cabid)) : null
        if (Array.isArray(cached)) return cached
        throw err
    }
}
export async function getCommentId(id) {
    let ruta = `${RUTA_JAVA}${RUTA_OBSERVACIONES}/${id}`
    let user = getUser();
    let token = user.token;
    let options = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        }
    }
    let res_all = await fetch(ruta, options)
    let data_all = await res_all.json()

    let procesada = processComment(data_all)
    return procesada
}
function postData(data) {
    let data_comment = {
        observationDate: data.fecha.split(" ")[0],
        animalId: data.animal,
        notes: data.observacion,
        establishmentId:data.cab
    }
    return data_comment
}
export async function saveComment(data) {
    let ruta = `${RUTA_JAVA}${RUTA_OBSERVACIONES}`
    let data_birth = postData(data)
    let user = getUser();
    let token = user.token;
    let res_save = await fetch(ruta, {
        method: "POST",
        body: JSON.stringify(data_birth), // data can be `string` or {object}!
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        },
    })
    let data_save = await res_save.json()
    return data_save
}
export async function editComment(id, data) {
    let ruta = `${RUTA_JAVA}${RUTA_OBSERVACIONES}/${id}`

    let user = getUser();
    let token = user.token;
    let res_post = await fetch(ruta,
        {
            method: "PUT",
            body: JSON.stringify(data), // data can be `string` or {object}!
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
        }
    )

    let data_post = await res_post.json()
    return data_post
}
export async function eliminarComment(id) {
    let ruta = `${RUTA_JAVA}${RUTA_OBSERVACIONES}/delete/${id}`
    let user = getUser();
    let token = user.token;


    let res_post = await fetch(ruta,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
        }
    )

    //let data_post = await res_post.json()

    return {}
}